module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n1r4r8r-c08aad712f21824d6f51fed2283f88a3.svg";